export const collectionOrder = [
  'Bryant',
  'Bryant Petite',
  'Bryant Slipcovered',
  'Holt',
  'Holt Petite',
  'Sebastian',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];

export const collectionQuickLinks = [
  'Bryant',
  'Holt',
  'Sebastian',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];
